/* Floodlight · bulk quote builder (owner: home). Port of prototype vHome quote state + qbText.
   Ball / quantity / buyer chips update the live sentence and the WhatsApp send link. Works without JS
   (the send link is server-rendered with the default message). */
(function () {
  'use strict';
  if (window.SS_LOADED_quote) return;
  window.SS_LOADED_quote = true;
  var SS = window.SS = window.SS || {};

  function initQuote(sec) {
    var qb = sec.querySelector('[data-qb]');
    if (!qb || qb.__ssInit) return;
    qb.__ssInit = true;
    var d = qb.dataset;
    var num = function (v, f) { var n = parseInt(v, 10); return isNaN(n) ? f : n; };
    var min = Math.max(1, num(d.min, 1));
    var max = Math.max(min, num(d.max, 500));
    var step = Math.max(1, num(d.step, 1));
    var st = { qty: Math.min(max, Math.max(min, num(d.qty, min))), ball: d.ball || '', buyer: d.buyer || '' };
    var tpl = d.template || '';
    var out = qb.querySelector('[data-qb-out]');
    var msg = qb.querySelector('[data-qb-msg]');
    var send = qb.querySelector('[data-wa-link]') || qb.querySelector('a[href*="wa.me"]');

    var text = function () {
      return tpl.split('__QTY__').join(String(st.qty)).split('__BALL__').join(st.ball).split('__BUYER__').join(st.buyer);
    };
    var waLink = function (t) {
      if (typeof SS.waLink === 'function') return SS.waLink(t);
      return 'https://wa.me/' + (d.waDigits || '') + '?text=' + encodeURIComponent(t);
    };
    var press = function (sel, test) {
      Array.prototype.forEach.call(qb.querySelectorAll(sel), function (b) {
        var on = !!test(b);
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    var render = function () {
      if (out) out.textContent = String(st.qty);
      press('[data-qb-ball]', function (b) { return b.getAttribute('data-qb-ball') === st.ball; });
      press('[data-qb-qty]', function (b) { return num(b.getAttribute('data-qb-qty'), -1) === st.qty; });
      press('[data-qb-buyer]', function (b) { return b.getAttribute('data-qb-buyer') === st.buyer; });
      var t = text();
      if (msg) msg.textContent = t;
      if (send) send.setAttribute('href', waLink(t));
    };

    var onClick = function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (!b || !qb.contains(b)) return;
      if (b.hasAttribute('data-qb-ball')) st.ball = b.getAttribute('data-qb-ball');
      else if (b.hasAttribute('data-qb-buyer')) st.buyer = b.getAttribute('data-qb-buyer');
      else if (b.hasAttribute('data-qb-qty')) st.qty = Math.min(max, Math.max(min, num(b.getAttribute('data-qb-qty'), st.qty)));
      else if (b.hasAttribute('data-qb-step')) {
        var dir = num(b.getAttribute('data-qb-step'), 0) < 0 ? -1 : 1;
        st.qty = Math.min(max, Math.max(min, st.qty + dir * step));
      } else return;
      render();
    };
    qb.addEventListener('click', onClick);
    render();
    return function () { qb.removeEventListener('click', onClick); qb.__ssInit = false; };
  }

  function ready(type, init) {
    if (typeof SS.sectionReady === 'function') { SS.sectionReady(type, init); return; }
    var sel = '[data-section-type="' + type + '"]';
    var run = function (root) {
      var els = root.matches && root.matches(sel) ? [root] : root.querySelectorAll(sel);
      Array.prototype.forEach.call(els, function (el) { if (!el.__ssQuote) el.__ssQuote = init(el) || true; });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
    else run(document);
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll(sel), function (el) {
        if (typeof el.__ssQuote === 'function') el.__ssQuote();
        el.__ssQuote = null;
      });
    });
  }

  ready('home-bulk', initQuote);
})();
